/**
 * Keeps the promo-discounted price on the PDP after the theme's own JS
 * rewrites [data-product-price] / [data-compare-price] on variant change.
 * Only runs when [data-price-wrapper][data-promo-active] is present
 * (see snippets/product-price.liquid).
 *
 * Prices are derived from the product JSON (real prices in cents) rather
 * than parsed back out of the rendered text, so re-running is idempotent:
 * the discount can never be applied twice, whatever order this and
 * theme.js happen to run in.
 */
(function () {
  var root = document.querySelector('[data-price-wrapper][data-promo-active]');
  if (!root) return;

  var pct = parseInt(root.getAttribute('data-promo-pct'), 10);
  if (!pct || pct <= 0) return;

  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  var variants = readVariants();
  if (!variants) return;

  var applying = false;

  function readVariants() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      var product = data.product || data;
      return product && product.variants ? product.variants : null;
    } catch (e) {
      return null;
    }
  }

  function selectedVariantId() {
    var input = document.querySelector('[data-product-select], input[name="id"]:checked, input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function findVariant(id) {
    if (!id) return null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  /* Mirrors Shopify's money filter for the common format strings. */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withSeparators = parts[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1,');
    var noDecimals = /no_decimals/.test(moneyFormat);
    var amount = noDecimals ? withSeparators : withSeparators + '.' + parts[1];
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function apply() {
    if (applying) return;

    var priceEl = root.querySelector('[data-product-price]');
    if (!priceEl) return;

    var variant = findVariant(selectedVariantId());
    if (!variant || !variant.price) return;

    var discounted = Math.round((variant.price * (100 - pct)) / 100);
    var struck =
      variant.compare_at_price && variant.compare_at_price > variant.price
        ? variant.compare_at_price
        : variant.price;
    var discountedText = formatMoney(discounted);
    var originalText = formatMoney(struck);

    var compareEl = root.querySelector('[data-compare-price]');
    var priceNeedsUpdate = priceEl.textContent.trim() !== discountedText;
    var compareNeedsUpdate =
      compareEl && compareEl.textContent.trim() !== originalText;

    // Writing only on a mismatch keeps this convergent: once the DOM matches
    // the target values there is nothing left to write, so the observer
    // settles instead of looping.
    if (!priceNeedsUpdate && !compareNeedsUpdate) return;

    applying = true;

    if (priceNeedsUpdate) priceEl.textContent = discountedText;
    if (compareNeedsUpdate) compareEl.textContent = originalText;

    applying = false;
  }

  // NOTE: theme.js hides [data-compare-price] with the .hidden class for
  // products without a real compare_at_price. That class is deliberately
  // NOT touched here — removing it in JS starts an infinite mutation loop
  // against theme.js (MutationObserver callbacks are async, so the
  // `applying` guard cannot break it). It is overridden in CSS instead,
  // see the [data-promo-active] rule in snippets/product-price.liquid.

  apply();

  var observer = new MutationObserver(apply);
  observer.observe(root, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  // theme.js swaps variants without necessarily mutating this subtree,
  // so also react to the variant input itself changing.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.name === 'id') apply();
  });
})();
